import HttpClienteToken from '../../services/HttpClientToken';

import { RolProps } from '../../interfaces/catalogos/RolInterface';

export const Rol = () => {

    return new Promise<RolProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Rol/', token)
            .then( ({ data } : { data : RolProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerRoles = () => {

    return new Promise<RolProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Rol/ObtenerRoles', token)
            .then( ({ data } : { data : RolProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarRol = ( params: RolProps ) => {

    return new Promise<RolProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Rol/Actualizar', params, token)
            .then( ({ data } : { data : RolProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idRol: 0,              
                    nombre: '',
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarRol = ( params: RolProps ) => {

    return new Promise<RolProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Rol/Agregar', params, token)
            .then( ({ data } : { data : RolProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idRol: 0,             
                    nombre: '',      
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}